"use client";
import { Typography } from "@/components/ui/typography";
import Image from "next/image";
import Why from "./why";
import { Statistic } from "./statistic";
import Animation from "@/components/ui/animation";
import { scrollAnimation } from "@/constants/motion.variant";
import { useMediaQuery } from "react-responsive";

const Welcome = () => {
  const isSmallScreen = useMediaQuery({ query: "(max-width: 640px)" });

  return (
    <div className="relative w-full flex justify-center items-center lg:mb-96">
      <Image
        src="/images/bg-welcome.webp"
        width={1772}
        height={960}
        alt="background"
        className="w-full h-auto object-cover"
      />

      {/* Circular Overlay */}
      <Animation
        variants={scrollAnimation}
        viewPortAmount={isSmallScreen ? 0 : 0.6}
        className="absolute top-24 bg-gray-600 w-full max-sm:h-[1600px] max-lg:h-[900px] lg:aspect-square rounded-2xl lg:rounded-full flex justify-center items-center flex-col xl:px-56 px-10 md:px-20 overflow-hidden shadow-[0px_-3px_93.6px_5px_#33DD7F26]"
      >
        <video
          width="1024"
          height="1024"
          preload="none"
          className="absolute w-full h-full object-cover"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src="/video/aura.webm" type="video/webm" />
          Your browser does not support the video tag.
        </video>
        <div className="relative z-10 flex flex-col gap-10 not-only:xl:gap-24 items-center py-4">
          <div className="flex flex-col gap-4 items-center justify-center">
            <div className="flex flex-col text-nowrap justify-center">
              <div className="flex items-center">
                <Typography variant={"titleLight"}>
                  PLUS MONGOLIA&nbsp;
                </Typography>
                <Typography variant={"titleLight"} className="text-primary">
                  3.0
                </Typography>
                <Typography variant={"titleLight"}>-Д</Typography>
              </div>
              <Typography variant={"titleLight"} className="text-center">
                ТАВТАЙ МОРИЛ
              </Typography>
            </div>
            <Typography className="text-center max-xl:max-w-xl max-sm:max-w-sm">
              Бид 1 жилийн хугацаанд нийтдээ 170 Giveaway - ийг явуулж 450 гаруй
              азтанд 50 сая төгрөгийг өгсөн байна. Нуусан мөнгийг олоорой,
              Төрсөн өдрийн эзэн, Money challenge, Money Spin, Random pick,
              Өрийн бичиг гэх мэт маш олон төрлийн Giveaway-үүдийг ямар ч
              шалгуургүйгээр байнга явуулж байна. 
            </Typography>
          </div>
          <Statistic />
          <Why />
        </div>
      </Animation>
    </div>
  );
};

export default Welcome;
